import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { BreadcrumbsService } from '../core/breadcrumbs/breadcrumbs.service';
import { portInBreadcrumbsConfig } from './port-in-breadcrumbs.config';

@Injectable({ providedIn: 'root' })
export class PortInBreadcrumbsResolver implements Resolve<void> {
  private readonly breadcrumbsService = inject(BreadcrumbsService);

  resolve(): void {
    this.breadcrumbsService.addBreadcrumbData(portInBreadcrumbsConfig);
  }
}
